import React, { useState } from "react";
import styled from "styled-components";

import { parseUnitObjective } from "@examspark/api";
import { reactKeyFromIDSK, sortObjectivesItems } from "@examspark/common";
import {
  Text,
  Grid,
  Tooltip,
  VSpace,
  ContainerButton,
} from "@examspark/common-ui";
import {
  getObjectiveCategory,
  ObjectiveCategoryBadge,
} from "@examspark/customer/tcmpc";
import { ParsedTCMPCUnit, TeksObjectivesItem } from "@examspark/types";

import ObjectiveDetailModal from "../ObjectiveDetailModal";

const Styled = styled.div``;
const GridItem = styled(ContainerButton)`
  border: solid 1px #ddd;
  border-radius: 0.5rem;
  padding: 0.7rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  transition: all 0.5s ease;
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0);

  text-align: left;

  &:hover {
    border-color: #006699;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.1);
  }
`;

const ObjectiveAbbreviation = styled.div`
  flex: 1;
`;
const ObjectiveCategory = styled.div``;

const TEKSGrid = (props: {
  label?: string;
  objectives: TeksObjectivesItem[];
  unit: ParsedTCMPCUnit | undefined;
}) => {
  const [modalObjectivesIndex, setModalObjectivesIndex] = useState<number>();

  const objectives = sortObjectivesItems(props.objectives);
  const parsedObjectives = objectives?.map((o) => parseUnitObjective(o));

  return (
    <Styled>
      <ObjectiveDetailModal
        objectives={parsedObjectives}
        showIndex={modalObjectivesIndex}
        onShowIndexChange={setModalObjectivesIndex}
        unit={props.unit}
      />
      <VSpace>
        {!!props.label && <Text.H4>{props.label}</Text.H4>}
        <Grid size="10rem">
          {objectives.map((objectiveItem, index) => (
            <Tooltip
              key={reactKeyFromIDSK(objectiveItem)}
              tip={
                <div style={{ maxWidth: "20rem" }}>
                  {objectiveItem.objective.content}
                </div>
              }
              placement="top"
            >
              <GridItem
                onClick={() => {
                  setModalObjectivesIndex(index);
                }}
              >
                <ObjectiveAbbreviation>
                  {objectiveItem.objective.abbreviation}
                </ObjectiveAbbreviation>
                <ObjectiveCategory>
                  <ObjectiveCategoryBadge
                    value={getObjectiveCategory(objectiveItem.objective)}
                  />
                </ObjectiveCategory>
              </GridItem>
            </Tooltip>
          ))}
        </Grid>
      </VSpace>
    </Styled>
  );
};

export default TEKSGrid;
